// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4798":"da435b4806bf0154","9890":"db509ef771b3d43b"}[chunkId] + ".js";
};